const plugins = [
  { src: '~/plugins/api.js' },
  { src: '~/plugins/calc.js' },
  { src: '~/plugins/rules.js' },
  { src: '~/plugins/pattern.js' },
  { src: '~/plugins/filters.js' },
  { src: '~/plugins/seon.js' },
  { src: '~/plugins/vue-slick-carousel.js' },
  { src: '~/plugins/vue-good-table', ssr: false },
  { src: '~/plugins/webchat.js', ssr: false },
  { src: '~/plugins/services.js' },
  { src: '~/plugins/proxy.js', ssr: false },
  { src: '~/plugins/features.js' },
];

export default plugins;
